import { ExprError } from '../ExprError';
import * as Types from '../../Types';
import { validateArguments } from '../../SignatureValidation';
export function validationLogic(callNode, args, name) {
    const arity = args.length;
    const Name = name;
    const Signature = `${Name}(<expression>)`;
    const sig = {
        meta: { name: Name, signature: Signature, location: callNode.location },
        arguments: arity === 1
            ? [
                {
                    customValidation: (node) => {
                        const type = Types.getResolvedType(node);
                        if (!Types.nodeResolvesToNumericType(node)) {
                            return [
                                new ExprError.InvalidArgument(Name, null, `expected NUMERIC input but saw ${type}`, callNode.location),
                            ];
                        }
                        return [];
                    },
                },
            ]
            : ["NUMERIC"],
    };
    return validateArguments(sig, args);
}
export var Percentile1Fn;
(function (Percentile1Fn) {
    Percentile1Fn.Name = `PERCENTILE_1`;
    Percentile1Fn.Stage = "AGGREGATE";
    Percentile1Fn.Signature = `PERCENTILE_1(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile1Fn.Name,
            stage: Percentile1Fn.Stage,
            data: { type, role },
        };
    }
    Percentile1Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile1Fn.Name);
    }
    Percentile1Fn.validate = validate;
})(Percentile1Fn || (Percentile1Fn = {}));
export var Percentile5Fn;
(function (Percentile5Fn) {
    Percentile5Fn.Name = `PERCENTILE_5`;
    Percentile5Fn.Stage = "AGGREGATE";
    Percentile5Fn.Signature = `PERCENTILE_5(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile5Fn.Name,
            stage: Percentile5Fn.Stage,
            data: { type, role },
        };
    }
    Percentile5Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile5Fn.Name);
    }
    Percentile5Fn.validate = validate;
})(Percentile5Fn || (Percentile5Fn = {}));
export var Percentile25Fn;
(function (Percentile25Fn) {
    Percentile25Fn.Name = `PERCENTILE_25`;
    Percentile25Fn.Stage = "AGGREGATE";
    Percentile25Fn.Signature = `PERCENTILE_25(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile25Fn.Name,
            stage: Percentile25Fn.Stage,
            data: { type, role },
        };
    }
    Percentile25Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile25Fn.Name);
    }
    Percentile25Fn.validate = validate;
})(Percentile25Fn || (Percentile25Fn = {}));
export var MedianFn;
(function (MedianFn) {
    MedianFn.Name = `MEDIAN`;
    MedianFn.Stage = "AGGREGATE";
    MedianFn.Signature = `MEDIAN(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: MedianFn.Name,
            stage: MedianFn.Stage,
            data: { type, role },
        };
    }
    MedianFn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, MedianFn.Name);
    }
    MedianFn.validate = validate;
})(MedianFn || (MedianFn = {}));
export var Percentile75Fn;
(function (Percentile75Fn) {
    Percentile75Fn.Name = `PERCENTILE_75`;
    Percentile75Fn.Stage = "AGGREGATE";
    Percentile75Fn.Signature = `PERCENTILE_75(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile75Fn.Name,
            stage: Percentile75Fn.Stage,
            data: { type, role },
        };
    }
    Percentile75Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile75Fn.Name);
    }
    Percentile75Fn.validate = validate;
})(Percentile75Fn || (Percentile75Fn = {}));
export var Percentile95Fn;
(function (Percentile95Fn) {
    Percentile95Fn.Name = `PERCENTILE_95`;
    Percentile95Fn.Stage = "AGGREGATE";
    Percentile95Fn.Signature = `PERCENTILE_95(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile95Fn.Name,
            stage: Percentile95Fn.Stage,
            data: { type, role },
        };
    }
    Percentile95Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile95Fn.Name);
    }
    Percentile95Fn.validate = validate;
})(Percentile95Fn || (Percentile95Fn = {}));
export var Percentile99Fn;
(function (Percentile99Fn) {
    Percentile99Fn.Name = `PERCENTILE_99`;
    Percentile99Fn.Stage = "AGGREGATE";
    Percentile99Fn.Signature = `PERCENTILE_99(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Percentile99Fn.Name,
            stage: Percentile99Fn.Stage,
            data: { type, role },
        };
    }
    Percentile99Fn.make = make;
    function validate(callNode, callName, args) {
        return validationLogic(callNode, args, Percentile99Fn.Name);
    }
    Percentile99Fn.validate = validate;
})(Percentile99Fn || (Percentile99Fn = {}));
